import React, { Component, Fragment } from 'react';

import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles';
import { 
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle, 
    IconButton,
    Typography,
    Button, 
    AppBar,
    Toolbar,
    Box
} from '@material-ui/core';
import Close from '@material-ui/icons/Close';

const styles = theme => ({
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
    toolbar:{
        justifyContent: "space-between"
    }
  });

class PopUp extends Component {
    
    render() {
        const { close, text, fullScreen, title, disabledSubmit, submitTitle, cancelTitle, scroll, appbar, classes, submitColor, secondaryAction, primaryAppbar } = this.props;

        return (
            <Dialog
                disableEnforceFocus
                disableBackdropClick
                open={true}
                onClose={close}
                aria-labelledby="form-dialog-title"
                maxWidth={this.props.maxWidth || "lg"}
                fullScreen={fullScreen}
                fullWidth
                scroll={scroll || "body"}
            >
                <Box style={{ backgroundColor: "#fafafa" }}>
                    {appbar ? (
                        <AppBar style={{position: 'relative'}} color={primaryAppbar ? "primary" : "secondary"}>
                            <Toolbar className={classes.toolbar}>
                                <Typography variant="h6">{title}</Typography>
                                <>
                                    {secondaryAction ? (
                                        secondaryAction
                                    ) : null}
                                    <span> </span>
                                    {close ? (
                                        <IconButton aria-label="Close" className={classes.closeButton} onClick={close}>
                                            <Close />
                                        </IconButton>
                                    ) : null}
                                </>
                            </Toolbar>
                        </AppBar>
                    ) : (
                        <Fragment>
                            <DialogTitle disableTypography className={classes.root}>
                                <Typography variant="h5">{title}</Typography>
                                {secondaryAction ? (
                                    secondaryAction
                                ) : null}
                                {close ? (
                                    <IconButton aria-label="Close" className={classes.closeButton} onClick={close}>
                                        <Close />
                                    </IconButton>
                                ) : null}
                            </DialogTitle>
                            <p className="dialog-banner-footer"></p>
                        </Fragment>
                    )
                    
                    }
                    <DialogContent style={{ minHeight: "450px"}}>
                        { this.props.children || text }
                    </DialogContent>
                    
                    { this.props.submitAction &&
                    
                        <DialogActions>
                        
                            <Button variant="contained" onClick={this.props.submitAction} color={submitColor || "secondary"} disabled={disabledSubmit}>
                                {disabledSubmit ? 'Traitement en cours...' : submitTitle || "Valider"}
                            </Button>
                            <Button onClick={close} color="default">
                            {cancelTitle || "Annuler"}
                            </Button>
                        </DialogActions>
                    }
                </Box>
            </Dialog>
        );
    }
}
  
export default withMobileDialog()(withStyles(styles)(PopUp))